import { BRAND_NAME } from '@/config/nav';

export function AppFooter() {
  const year = new Date().getFullYear();
  return (
    <footer className="text-muted-foreground border-t px-4 py-4 text-center text-xs">
      © {year} {BRAND_NAME}. All rights reserved.
    </footer>
  );
}
